export default __webpack_public_path__ + "static/media/ic_keyboard_arrow_down_24px.985fdbf8.svg";